export default function initGoogleLogin() {
  window.ccFacStaffLogin = class ccFacStaffLogin {

    #loginWrapper;

    constructor(fieldId){

      this.#loginWrapper = document.getElementById(fieldId);

      // Make sure we found the right element for this POI field
      if(this.#loginWrapper){
        
        console.cclog('Initializing ccFacStaffLogin for #' + fieldId);

        this.render();
        
      } else {

        console.cclog('ERROR: ccFacStaffLogin could not find field by ID attribute #' + fieldId);
      }
    }
  
    loggedInUser() {
      var cookies = document.cookie.split(';'), i = cookies.length, c;
      while (i--) {
          c = cookies[i].split('=');
          c[0] = c[0].replace(/(^\s\s*|\s\s*$)/, '');
          if (c[0] == 'wwwsession') {
            return decodeURIComponent(c[1]).split('|')[1];
          }
      }
    }
  
    getUserName(email){
      return fetch('https://my.champlain.edu/attributes/get?email='+email).then((data) => data.json()).then((json) => {
        let first = json.find(i => i.name == 'first_name');
        let last = json.find(i => i.name == 'last_name');
        return first.value + ' ' + last.value;
      });
    }

    render(){

      const currentUser = this.loggedInUser();
      
      if(currentUser){

        let welcomeSpan = document.createElement('span');
        
        this.getUserName(currentUser).then((name)=>{
          welcomeSpan.textContent = 'Welcome ' + name;
        })
        
        let googleLogoutLink = document.createElement('a');
        googleLogoutLink.className = 'btn btn-md btn-secondary';
        googleLogoutLink.textContent = 'Logout';
        googleLogoutLink.href = 'https://my.champlain.edu/auth/logout?redirect=' + window.location.href;
        
        this.#loginWrapper.append(welcomeSpan);
        this.#loginWrapper.append(document.createElement('br'));
        this.#loginWrapper.append(googleLogoutLink);
      } else {

        let googleAuthLink = document.createElement('a');
        googleAuthLink.className = 'btn btn-md btn-primary';
        googleAuthLink.textContent = 'Sign in with Google';

        const self = this;
        googleAuthLink.onclick = () => {
          self.login();
        };

        let googleForgotLink = document.createElement('a');
        googleForgotLink.textContent = 'Forgot your username or password?';
        googleForgotLink.href = 'https://welcome.champlain.edu/showLogin.cc';

        this.#loginWrapper.append(googleAuthLink);
        this.#loginWrapper.append(document.createElement('br'));
        this.#loginWrapper.append(googleForgotLink);
      }
    }
  
    login() {
      const url = 'https://my.champlain.edu/auth/googlelogin';

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      
      const redirectInput = document.createElement('input');
      redirectInput.type = 'hidden';
      redirectInput.name = 'redirect';
      redirectInput.value = window.location.href;
      form.appendChild(redirectInput);

      const nogoogleInput = document.createElement('input');
      nogoogleInput.type = 'hidden';
      nogoogleInput.name = 'nogoogle';
      nogoogleInput.value = '1';
      form.appendChild(nogoogleInput);
      
      document.body.appendChild(form);
      
      form.submit();
    }
  }
}